export enum LogoKey {
  PWC = 'PWC',
  UNICREDIT = 'UNICREDIT',
  P4E = 'P4E',
  FONDITAL = 'FONDITAL',
  FIVESIXTY = 'FIVESIXTY',
}
